import { render, staticRenderFns } from "./TreatmentDose.vue?vue&type=template&id=80778418&scoped=true"
import script from "./TreatmentDose.vue?vue&type=script&lang=js"
export * from "./TreatmentDose.vue?vue&type=script&lang=js"
import style0 from "./TreatmentDose.vue?vue&type=style&index=0&id=80778418&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80778418",
  null
  
)

export default component.exports